import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const FooterWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Lato;
  font-weight: bold;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          flex-direction:  ${props.$isLastWizardPage ? 'column' : 'row'};
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const GroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  :first-child {
    margin: 10px 0 10px 20px;
  }
  :last-child {
    margin: 10px 20px 10px 10px;
  }

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          margin: 0;
          width: 100%;

          :first-child, :last-child {
            margin: 0;
          }
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const ButtonWrapper = styled.div`
  font-family: Lato;
  display: flex;
  margin-left: 10px;
  :first-child {
    margin-left: 0;
  }
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  cursor: pointer;
  width: auto;
  height: auto;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          width: 100%;
          height: 65px;
          border-radius: 0;
          margin: 0;
          border-left: solid 2px ${colors.primary};
          :first-child {
            border: none;
          }
        `;
      }
      default: {
        return null;
      }
    }
  }}

  * {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px ${colors.primary};
    font-size: 18px;
    width: 200px;
    height: 50px;

    ${props => {
      const { core: { targetDevice } } = store.getState();

      switch (targetDevice) {
        case SMARTPHONE: {
          return css`
            border: none;
            width: 100%;
            height: 100%;
            padding: 15px;
            border-radius: 0;
          `;
        }
        default: {
          return null;
        }
      }
    }}
  }

  .secondary {
    border: none;
    color: ${colors.primary};
    background-color: ${colors.backgroundButton};
  }
`;
